export interface MfaChallengePayload {
  requires_mfa: true;
  mfa_token: string;
}

export function isMfaChallenge(data: unknown): data is MfaChallengePayload {
  if (!data || typeof data !== 'object') return false;
  const record = data as Record<string, unknown>;
  return record['requires_mfa'] === true && typeof record['mfa_token'] === 'string';
}
